namespace RioERP.Reports {
    export interface TeacherOutstandingForm {
        OrderId: Serenity.IntegerEditor;
        OrderProductsId: Serenity.IntegerEditor;
        TeacherId: Serenity.LookupEditor;
        SharePercentage: Serenity.DecimalEditor;
        OrderProdutcsCost: Serenity.DecimalEditor;
        ShareAmount: Serenity.DecimalEditor;
        Qty: Serenity.IntegerEditor;
        SettelmentId: Serenity.IntegerEditor;
        ESettelementStatus: Serenity.IntegerEditor;
        TotalShare: Serenity.DecimalEditor;
        IsActive: Serenity.BooleanEditor;
        InsertUserId: Serenity.IntegerEditor;
        InsertDate: Serenity.DateEditor;
        UpdateUserId: Serenity.IntegerEditor;
        UpdateDate: Serenity.DateEditor;
    }

    export class TeacherOutstandingForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.TeacherOutstanding';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TeacherOutstandingForm.init)  {
                TeacherOutstandingForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DateEditor;

                Q.initFormType(TeacherOutstandingForm, [
                    'OrderId', w0,
                    'OrderProductsId', w0,
                    'TeacherId', w1,
                    'SharePercentage', w2,
                    'OrderProdutcsCost', w2,
                    'ShareAmount', w2,
                    'Qty', w0,
                    'SettelmentId', w0,
                    'ESettelementStatus', w0,
                    'TotalShare', w2,
                    'IsActive', w3,
                    'InsertUserId', w0,
                    'InsertDate', w4,
                    'UpdateUserId', w0,
                    'UpdateDate', w4
                ]);
            }
        }
    }
}
